module.exports = __webpack_public_path__ + "static/TalkRelease-e59fc4db6cffc6c2b6e302fb8c3b808b.png";